import { defineMessages } from 'react-intl';

export const orderingMessages = defineMessages({
  orderPickupTypeInStore: {
    id: 'shared.orderPickupTypeInStore',
    defaultMessage: 'In-store pickup',
    description: 'label for in-store pickup type',
  },
  orderPickupTypeDriveThru: {
    id: 'shared.orderPickupTypeDriveThru',
    defaultMessage: 'Drive-thru pickup',
    description: 'label for drive-thru pickup type',
  },
  orderPickupTypeCurbside: {
    id: 'shared.orderPickupTypeCurbside',
    defaultMessage: 'Curbside pickup',
    description: 'label for curbside pickup type',
  },
  scheduledOrderingPickupTimeSlot: {
    id: 'shared.scheduledOrderingPickupTimeSlot',
    defaultMessage: 'Pickup between {timeSlot}',
    description:
      'order pickup time message for if scheduled ordering is enabled',
  },
  storeAtCapacityDialogHeading: {
    id: 'shared.storeAtCapacityDialogHeading',
    description: 'Heading for store at capacity dialog',
    defaultMessage: 'This store is at capacity for ordering ahead',
  },
  storeAtCapacityDialogBody: {
    id: 'shared.storeAtCapacityDialogBody',
    description: 'Body copy for store at capacity dialog',
    defaultMessage:
      'We’re giving every order the attention it deserves. Please check pickup times again in a few minutes or select a different pickup store.',
  },
  timeSlotRescheduledDialogHeading: {
    id: 'ordering.timeSlotRescheduledDialogHeading',
    description: 'Heading for time slot rescheduled dialog',
    defaultMessage: 'The next pickup time is {scheduledTimeSlot}',
  },
  timeSlotRescheduledDialogBody: {
    id: 'ordering.timeSlotRescheduledDialogBody',
    description: 'Body copy for time slot rescheduled dialog',
    defaultMessage:
      'Your pickup time is no longer available. We’ve updated it to the first available slot, please choose a different time if needed. Thanks!',
  },
});
